import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {SharedModule} from '../shared/shared.module'
import {BreadcrumbComponent} from './breadcrumb.component'
import {RouterModule} from '@angular/router'

@NgModule({
  declarations: [BreadcrumbComponent],
  exports: [BreadcrumbComponent],
  imports: [CommonModule, RouterModule, SharedModule],
})
export class BreadcrumbModule {
}
